var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNuma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 24,
    viewBox: "0 0 94 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2624_31187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7717 15.4673L4.43605 0.173703C4.36315 0.0656243 4.23906 0 4.10708 0H0.393965C0.177288 0 0 0.173703 0 0.386008V23.313C0 23.5252 0.177288 23.699 0.393965 23.699H4.06177C4.27846 23.699 4.45573 23.5252 4.45573 23.313V8.4169C4.45573 8.03476 4.96396 7.88421 5.17866 8.20459L15.5143 23.5272C15.5872 23.6352 15.7113 23.7009 15.8434 23.7009H19.5564C19.7732 23.7009 19.9503 23.5272 19.9503 23.3149V0.386008C19.9503 0.173703 19.7732 0 19.5564 0H15.8886C15.6719 0 15.4946 0.173703 15.4946 0.386008V15.2531C15.4946 15.6353 14.9884 15.7858 14.7717 15.4653V15.4673Z",
    fill: "url(#paint0_linear_2624_31187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2995 15.3053C35.2995 16.8589 34.8936 18.0671 34.092 18.8932C33.306 19.7037 32.2561 20.0994 30.8811 20.0994C29.5061 20.0994 28.4562 19.7057 27.6743 18.897C26.8942 18.0709 26.4983 16.8628 26.4983 15.3071V5.20339C26.4983 4.99109 26.321 4.81738 26.1043 4.81738H22.47C22.2533 4.81738 22.076 4.99109 22.076 5.20339V15.8706C22.076 17.5731 22.4188 19.0514 23.0983 20.2654C23.8016 21.4832 24.7649 22.4155 25.9664 23.037C27.1779 23.6545 28.5587 23.9672 30.0695 23.9672C31.2141 23.9672 32.3034 23.7472 33.3119 23.309C33.8083 23.089 34.2594 22.8285 34.6672 22.5312C34.9291 22.3402 35.3015 22.5158 35.3015 22.8362V23.315C35.3015 23.5272 35.4786 23.701 35.6954 23.701H39.3632C39.5799 23.701 39.7571 23.5272 39.7571 23.315V5.20339C39.7571 4.99109 39.5799 4.81738 39.3632 4.81738H35.6954C35.4786 4.81738 35.3015 4.99109 35.3015 5.20339V15.3053H35.2995Z",
    fill: "url(#paint1_linear_2624_31187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0364 5.44846C67.8466 4.83085 66.4756 4.51819 64.9648 4.51819C63.5406 4.51819 62.1913 4.8656 60.9582 5.55076C60.0619 6.03133 59.3271 6.64508 58.7657 7.3843C58.6061 7.59466 58.291 7.59466 58.1334 7.3843C57.5365 6.59491 56.7821 5.95799 55.8838 5.48321C54.6705 4.84243 53.2778 4.51819 51.7433 4.51819C50.5989 4.51819 49.5096 4.7382 48.505 5.1744C48.0124 5.38863 47.5574 5.64532 47.1438 5.94448C46.8818 6.13362 46.5115 5.95799 46.5115 5.63761V5.20335C46.5115 4.99105 46.3342 4.81734 46.1175 4.81734H42.4496C42.2331 4.81734 42.0558 4.99105 42.0558 5.20335V23.3149C42.0558 23.5272 42.2331 23.7009 42.4496 23.7009H46.1175C46.3342 23.7009 46.5115 23.5272 46.5115 23.3149V13.1802C46.5115 11.6265 46.9054 10.4299 47.6855 9.62507C48.4931 8.79128 49.5549 8.38597 50.9299 8.38597C52.3048 8.38597 53.3526 8.78935 54.1405 9.62507C54.9188 10.4299 55.3146 11.6246 55.3146 13.1802V23.3149C55.3146 23.5272 55.492 23.7009 55.7085 23.7009H59.3429C59.5595 23.7009 59.7368 23.5272 59.7368 23.3149V13.1802C59.7368 11.6265 60.1309 10.4299 60.9108 9.62507C61.7184 8.79128 62.7802 8.38597 64.1552 8.38597C65.5302 8.38597 66.5781 8.78935 67.366 9.62507C68.1441 10.4299 68.54 11.6246 68.54 13.1802V23.3149C68.54 23.5272 68.7173 23.7009 68.934 23.7009H72.5683C72.785 23.7009 72.9623 23.5272 72.9623 23.3149V12.6147C72.9623 10.9105 72.6077 9.43206 71.9084 8.22386C71.2268 7.00407 70.2616 6.06993 69.0404 5.44846H69.0364Z",
    fill: "url(#paint2_linear_2624_31187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5088 5.20335V6.1124C89.5088 6.43858 89.1228 6.61613 88.8647 6.40963C88.4018 6.03905 87.8779 5.70709 87.3007 5.41758C86.1778 4.8212 84.8404 4.51819 83.3295 4.51819C81.6551 4.51819 80.099 4.93507 78.7044 5.75534C77.3314 6.55438 76.2224 7.69696 75.4069 9.15606C74.619 10.6094 74.2191 12.2982 74.2191 14.1761C74.2191 16.054 74.617 17.7621 75.4069 19.2636C76.2184 20.7401 77.3256 21.9174 78.7004 22.7609C80.0754 23.5832 81.6099 24 83.2625 24C84.7497 24 86.0972 23.6989 87.2633 23.1044C87.8562 22.8034 88.388 22.4599 88.8588 22.0757C89.1188 21.8654 89.5109 22.0372 89.5109 22.3672V23.3149C89.5109 23.5272 89.6882 23.7009 89.9047 23.7009H93.6061C93.8228 23.7009 94 23.5272 94 23.3149V5.20335C94 4.99105 93.8228 4.81734 93.6061 4.81734H89.9047C89.6882 4.81734 89.5109 4.99105 89.5109 5.20335H89.5088ZM89.5088 14.2417C89.5088 15.448 89.2469 16.5191 88.7308 17.4243C88.2402 18.3026 87.5803 18.9799 86.7727 19.4393C85.9632 19.8986 85.0786 20.1303 84.1411 20.1303C83.2036 20.1303 82.3387 19.8967 81.5133 19.4413C80.7017 18.9606 80.03 18.2581 79.5179 17.3606C79.0235 16.4555 78.7733 15.3843 78.7733 14.1761C78.7733 12.9679 79.0235 11.9218 79.514 11.0649C80.0261 10.1867 80.6958 9.51892 81.5075 9.07886C82.3169 8.61952 83.2014 8.38792 84.1391 8.38792C85.0768 8.38792 85.9612 8.62145 86.7709 9.07886C87.5783 9.53629 88.2364 10.2157 88.7308 11.0977C89.2449 11.9797 89.5048 13.0374 89.5048 14.2417H89.5088Z",
    fill: "url(#paint3_linear_2624_31187)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2624_31187",
    x1: 97.1939,
    y1: -74.6532,
    x2: 14.4916,
    y2: 9.75593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27EAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B688FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2624_31187",
    x1: 109.148,
    y1: -63.327,
    x2: 26.4434,
    y2: 21.0802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27EAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B688FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2624_31187",
    x1: 122.719,
    y1: -50.4158,
    x2: 40.0164,
    y2: 33.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27EAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B688FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2624_31187",
    x1: 137.308,
    y1: -36.1191,
    x2: 54.6059,
    y2: 48.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27EAA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B688FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_31187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNuma);
export default __webpack_public_path__ + "static/media/logo-numa.26c5b760509efad22bef24f1632cf5be.svg";
export { ForwardRef as ReactComponent };